<style lang="scss">
  /*
  *
  *
  *
  *
  *
  GLOBAL
  *
  *
  *
  *
  *
  */
  $primaryColor: #B9DD64;
  $errorColor: #DF3132;
  $black: #232323;
  body {
    font-family: 'Montserrat', sans-serif !important;
    color: $black !important;
    cursor: default;
  }
  ul {
    padding: 0;
    list-style: none;
  }
  img {
    width: 100%;
    height: auto;
  }
  :focus,
  a:focus,
  .btn:focus {
    outline: none;
    box-shadow: none;
  }
  a,
  .btn-link,
  a:hover,
  .btn-link:hover {
    color: $primaryColor;
  }
  .btn {
    width: 260px;
    height: 48px;
    line-height: 48px;
    padding: 0;
    font-weight: 600;
    border: none;
  }
  .btn-primary {
    background-color: $primaryColor;
    &:hover,
    &:not(:disabled):not(.disabled).active,
    &:not(:disabled):not(.disabled):active {
      background-color: darken($primaryColor, 20%);
    }
  }
  .btn-default {
    background-color: #c1c1c1;
    color: #fff;
    &:hover {
      background-color: darken(#c1c1c1, 20%);
      color: #fff;
    }
  }
  .btn-outline {
    background-color: #fff;
    color: $black;
    border: 1px solid $primaryColor;
    &:hover {
      background-color: $primaryColor;
      color: #fff;
    }
  }
  .btn-icon {
    padding: 0;
    height: 22px;
    img {
      height: 100%;
      width: auto;
      vertical-align: top;
    }
  }
  .text-primary {
    color: $primaryColor !important;
  }
  strong {
    font-weight: 600;
  }
  .container {
    padding-right: 15px;
    padding-left: 15px;
  }
  @media (min-width: 1200px) {
    .container {
      max-width: 1250px;
    }
  }
  .bookProgress {
    position: absolute;
    justify-content: space-around;
    >div {
      position: absolute;
      top: 12px;
      right: 12px;
      bottom: 12px;
      left: 12px;
      padding-top: 36px;
      text-align: center;
      font-weight: 600;
      color: #fff;
      border-radius: 50%;
      background-color: #4F4F58;
    }
    svg {
      display: block;
      margin: 0;
      max-width: 100%;
      overflow: visible;
      .circle-bg {
        fill: none;
        stroke: #f2f2f2;
        stroke-width: 5;
      }
      .circle {
        fill: none;
        stroke-width: 5;
        stroke-linecap: none;
        stroke: $primaryColor;
        animation: progress 1.2s ease-out forwards;
      }
    }
    &.bpNoanim {
      svg {
        .circle {
          animation: none;
        }
      }
    }
  }
  @keyframes progress {
    0% {
      stroke-dasharray: 0 100;
    }
  }
  /*
  *
  *
  *
  *
  *
  NAV
  *
  *
  *
  *
  *
  */
  nav {
    display: grid;
    grid-template-columns: 80px 1fr 120px;
    grid-gap: 20px;
    margin-bottom: 50px;
    padding: 20px 0;
    align-items: center;
    position: relative;
    .search {
      form {
        position: absolute;
        top: 60px;
        right: 0;
        left: 0;
        opacity: 0;
        -webkit-transition: all .3s ease-in-out;
        -moz-transition: all .3s ease-in-out;
        -ms-transition: all .3s ease-in-out;
        -o-transition: all .3s ease-in-out;
        transition: all .3s ease-in-out;
        pointer-events: none;
        &.searchVisible {
          opacity: 1;
          pointer-events: all;
        }
        .form-control.searchInput {
          padding-left: 0;
          border: none;
          border-bottom: 1px solid #ced4da;
          border-radius: 0;
          font-size: 14px;
          font-weight: 600;
          &:focus {
            box-shadow: none;
          }
        }
      }
      @media (min-width: 576px) {
        &.search {
          display: grid;
          grid-template-columns: 22px 1fr;
          grid-gap: 20px;
          align-items: center;
        }
        form {
          top: 60px;
          right: 120px;
          left: 135px;
        }
      }
      @media (min-width: 768px) {
        form {
          position: relative;
          top: 0;
          right: 0;
          left: 0;
        }
      }
    }
    .navBtns {
      text-align: right;
      .btnCart {
        position: relative;
        span {
          position: absolute;
          top: -12px;
          right: -16px;
          background-color: $primaryColor;
          color: #fff;
          width: 20px;
          height: 20px;
          line-height: 20px;
          font-size: 12px;
          text-align: center;
          border-radius: 10px;
        }
      }
      .btnMenu {
        margin-left: 35px;
      }
    }
    .btn {
      width: auto;
    }
    .menu {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 999;
      text-align: center;
      background-color: rgba(255, 255, 255, .95);
      transition: all .4s;
      opacity: 0;
      overflow: hidden;
      pointer-events: none;
      .container {
        text-align: right;
        .closeBtn {
          width: 26px;
          margin-top: 21px;
          font-weight: 800;
          color: $black;
        }
      }
      ul {
        margin-top: 10%;
        text-align: center;
        li a {
          display: block;
          padding: 20px;
          font-size: 26px;
          font-weight: 800;
          color: $black;
        }
      }
    }
  }
  body.menuOpen {
    overflow: hidden;
  }
  .menuOpen nav .menu {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 1;
    pointer-events: all;
    overflow-y: auto;
  }
  @media (max-width: 767px) {
    nav {
      .btn-icon {
        height: 16px;
      }
    }
  }
  @media (min-width: 768px) {
    nav {
      grid-gap: 50px;
      grid-template-columns: 115px 1fr 120px;
      margin-bottom: 150px;
      .navBtns .btnMenu {
        margin-left: 50px;
      }
    }
  }
  @media (min-width: 992px) {
    nav {
      grid-gap: 80px;
    }
  }
  /*
  *
  *
  *
  *
  *
  BOOKS
  *
  *
  *
  *
  *
  */
  .books,
  .mbWr {
    li,
    .swiper-wrapper,
    .mobileBooks {
      a {
        display: block;
        color: $black;
        &:hover {
          text-decoration: none;
        }
        .bCover {
          width: 100%;
          padding: 0 0 142% 0;
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
        }
        h3 {
          min-height: 92px;
          margin: 40px 0 10px 0;
          font-size: 18px;
          font-weight: 600;
          small {
            display: block;
            margin-top: 10px;
            font-size: 14px;
          }
        }
        p {
          span {
            color: $primaryColor;
          }
        }
        .btn {
          width: 100%;
          padding-right: 30px;
          padding-left: 30px;
        }
      }
    }
  }
  /*
  *
  *
  *
  *
  *
  RENDELÉSI FOLYAMAT
  *
  *
  *
  *
  *
  */
  .cartContent {
    h1 {
      margin: 0 0 40px;
      font-weight: 800;
      text-transform: uppercase;
    }
    p {
      margin: 20px 0 40px 0;
      font-size: 14px;
    }
    .btn {
      text-transform: uppercase;
    }
    .orderProgress {
      margin-bottom: 80px;
      > * {
        display: inline-block;
        vertical-align: top;
      }
      span {
        line-height: 14px;
        font-size: 14px;
        text-transform: uppercase;
        color: #c1c1c1;
        &.active {
          color: $black;
        }
      }
      i {
        margin: 0 5px;
        width: 10px;
        height: 13px;
        background: #fff url('/static/images/icons/cart-right.svg') center no-repeat;
        background-size: contain;
      }
    }
    form {
      > p {
        margin-bottom: 70px;
      }
      p.errors {
        padding: 12px 15px;
        font-weight: 600;
        color: #fff;
        background-color: $errorColor;
        border-radius: 4px;
        span:not(:first-of-type) {
          &:before {
            content: ', '
          }
        }
      }
      .form-group.floating {
        position: relative;
        margin-bottom: 60px;
        &.hasError {
          label {
            color: $errorColor
          }
          input {
            border-bottom-color: $errorColor
          }
        }
        label {
          position: absolute;
          top: 5px;
          left: 0;
          font-size: 14px;
          transition: all .3s;
        }
        input {
          padding: 0 0 10px 0;
          font-size: 14px;
          font-weight: 600;
          border: none;
          border-bottom: 1px solid #f2f2f2;
          border-radius: 0;
          &:focus {
            box-shadow: none;
          }
          &:focus + label,
          &.hasValue + label {
            top: -30px;
            font-size: 12px;
          }
        }
      }
      .custom-control.custom-radio {
        padding: 0;
        border-bottom: 1px solid #f2f2f2;
        .custom-control-label {
          padding: 20px 0 20px 60px;
          font-size: 14px;
          &:before {
            top: 50%;
            left: 0;
            width: 22px;
            height: 22px;
            margin: -11px 0 0 0;
          }
          strong {
            font-size: 16px;
          }
        }
        .custom-control-input:checked~.custom-control-label::before {
          border-color: #fff;
          background-color: $black;
          border-width: 2px;
          -webkit-box-shadow: 0 0 0 2px $black;
          box-shadow: 0 0 0 2px $black;
        }
      }
      .custom-control.custom-checkbox {
        &.hasError {
          .custom-control-label {
            color: $errorColor;
            a {
              color: $errorColor;
            }
          }
        }
        .custom-control-label {
          line-height: 24px;
          font-size: 12px;
        }
        .custom-control-input:checked~.custom-control-label::before {
          background-color: $black;
          border: 1px solid $black;
          -webkit-box-shadow: none;
          box-shadow: none;
        }
      }
      .custom-control-input:focus:not(:checked)~.custom-control-label::before {
        border: 1px solid #adb5bd;
      }
      .custom-control-input:focus~.custom-control-label::before {
        box-shadow: none;
      }
    }
  }
  /*
  *
  *
  *
  *
  *
  FOOTER
  *
  *
  *
  *
  *
  */
  footer {
    margin-top: 150px;
    padding: 100px 0 0 0;
    background-color: #f2f2f2;
    .social {
      text-align: right;
    }
    img {
      max-width: 110px;
    }
    a {
      display: inline-block;
      color: #232323;
      opacity: .85;
      .fab {
        margin-top: 11px;
        font-size: 26px;
      }
      &+a {
        margin-left: 20px;
      }
    }
    form {
      position: relative;
      .form-control {
        height: 48px;
        font-size: 14px;
        background-color: transparent;
        border-color: #fff;
        border-width: 2px;
      }
      .btn {
        background-color: transparent;
        text-transform: uppercase;
        color: $primaryColor;
        border-radius: 4px !important;
        border-width: 2px;
      }
      .form-control-feedback {
        position: absolute;
        top: -30px;
        right: 0;
        left: 15px;;
        font-weight: 600;
        color: $errorColor;
      }
    }
    .fLinks {
      margin: 0;
      padding: 50px 0 20px 0;
      text-align: center;
      a {
        margin: 0 20px;
        font-size: 12px;
      }
    }
  }
  @media (max-width: 1200px) {
    footer form .btn {
      width: auto;
      padding-right: 30px;
      padding-left: 30px;
    }
    footer .social {
      text-align: center;
    }
  }
  @media (max-width: 992px) {
    footer {
      text-align: center;
      .social {
        a {
          margin: 40px;
        }
      }
    }
  }
  @media (max-width: 767px) {
    footer {
      .input-group>.form-control,
      form .btn,
      .input-group-append {
        text-align: center;
        display: block;
        width: 100%;
        border-radius: 4px !important;
      }
      .input-group-append {
        margin-top: 10px;
      }
      .social {
        a {
          margin: 40px 20px;
        }
      }
    }
  }
  .toastWr {
    position: fixed;
    top: 50%;
    left: 0;
    right: 0;
    margin: -39px 0 0 0;
    z-index: 999;
    pointer-events: all;
    .toast {
      max-width: 100%;
      width: 100%;
      .toast-header {
        padding: 20px 40px 20px 20px;
        background-color: $primaryColor;
        color: #fff;
        border: none;
        position: relative;
        text-align: center;
        p {
          display: block;
          margin: 0;
          width: 100%;
          font-size: 24px;
          font-weight: 600;
        }
        button.close {
          position: absolute;
          top: 10px;
          right: 14px;
          color: #fff;
        }
      }
    }
    &:not(.show) {
      pointer-events: none;
    }
  }
</style>
<template>
  <div id="app" class="m-grid m-grid--hor m-grid--root m-page">
    <transition name="fade">
      <router-view v-if="loaded"></router-view>
    </transition>
    <!-- begin::Scroll Top -->
    <div id="m_scroll_top" class="m-scroll-top">
      <i class="la la-arrow-up"></i>
    </div>
    <!-- end::Scroll Top -->
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      loader: true,
      loaded: false,
      cartNum: 0,
      txtContent: {
        homeTitle: '',
        homeText: '',
        booksubCart: '',
        booksubWebshop: ''
      }
    }
  },
  created () {
    let url = process.env.API_URL + '/' + process.env.API_ENDPOINT
    this.$http
      .get(url + `/pages`, {
        'headers': {
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        this.txtContent.homeTitle = this.getTxtContent('/title', res.data.data)
        this.txtContent.homeText = this.getTxtContent('/txt', res.data.data)
        this.txtContent.booksubCart = this.getTxtContent('/booksub-cart', res.data.data)
        this.txtContent.booksubWebshop = this.getTxtContent('/booksub-webshop', res.data.data)
        this.$store.commit('loading/setTxtContent', this.txtContent)
      }).catch(res => {
      })
  },
  methods: {
    getTxtContent: function (_url, _obj) {
      for (let i = 0; i < _obj.length; i++) {
        if (_obj[i].url === _url) {
          return _obj[i].content
        }
      }
    },
    setLanguage () {
      let lang = this.$store.state.loading.language
      if (localStorage.getItem('language') !== null) {
        lang = localStorage.getItem('language')
      }
      this.$translate.locale = lang
      this.$translate.setLocaleMessage(lang, this.$store.state.loading.languages[lang])
      this.$store.commit('loading/changeLanguage', lang)
    }
  },
  mounted () {
    window.$('.toast').toast()
    this.loaded = true
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue